import styled from "styled-components/macro";


export const ButtonWrapper = styled.div`
  padding-right: 1em;
  display: flex;
  justify-content: flex-end;

  margin-top: 1em;
  gap: 0.5em;
`;


export const PopUpButton = styled.button`

  padding: 1em 1.5em;
  border: #414340;

  background: gray;

  color: #edebeb;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;

  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: ${({ active }) => active && "#1f729f"};
  padding: 0.5em 1.5em;
  display: inline;

  &:focus {
    background-color: #1f729f;
  }
`;